import { Injectable } from '@angular/core';
import {
  UserService,
  UserBaseAllBaseWriteUserAllUserWrite
} from '../openapi';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { UserDetails } from '../store/reducers/user-details.reducer';
import { environment } from '../../environments/environment';
import { LoginResponse } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { SessionService } from './ssession.service';

@Injectable({
  providedIn: 'root'
})
export class UserCommonService {
  constructor(
    private userService: UserService,
    private httpClient: HttpClient
  ) {
  }

  public loadUserDetails(): Observable<UserDetails | null> {
    return this.userService.getCurrentUserUserCollection({
      pagination: false
    }).pipe(
      map(v => v as UserDetails || null),
      catchError(() => of(null))
    );
  }

  public updateUserDetails(id: string, user: UserBaseAllBaseWriteUserAllUserWrite): Observable<UserDetails | null> {
    return this.userService.updateCurrentUserUserItem({
      user,
      id
    }).pipe(
      switchMap((v) => this.generateNewToken().pipe(
          map(data => {
            if (data?.token) {
              SessionService.SetAccessToken(data.token);
            }
            return v;
          })
        )
      )
    );
  }

  public generateNewToken(): Observable<LoginResponse> {
    return this.httpClient.get<LoginResponse>(`${environment.apiBasePath}/user/generate-new-token`);
  }

}
